import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { usePopoverHandlers } from '@as/cotopaxi';
import { CaretDownIcon, CaretUpIcon } from '@yonderland/andes-icons';
import { Button, Icon, Stack, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { generateTestId } from '../../util/TestUtil';
import { SortControlPopover } from './SortControlPopover';
const TEST_ID = 'sort-control';
export const SortControl = props => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { orderItems, currentOrderItem, onOrderChange } = props;
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const onItemClick = (newOrder) => {
        handlePopoverClose();
        return onOrderChange(newOrder);
    };
    return (_jsxs(Stack, { wrap: "wrap", align: "center", testId: TEST_ID, children: [_jsxs(TextAlpha, { as: "span", testId: generateTestId({ testId: TEST_ID, suffix: 'text' }), children: [t('product:product.sort'), ":", ' '] }), _jsxs(Button, { variant: "primary", onClick: handlePopoverOpen, size: "sm", inverse: true, testId: generateTestId({ testId: TEST_ID, suffix: 'btn' }), children: [t(`product:${currentOrderItem.value}`), _jsx(Icon, { source: anchorEl ? CaretUpIcon : CaretDownIcon, color: "active", testId: generateTestId({ testId: TEST_ID, suffix: 'btn-icon' }) })] }), _jsx(SortControlPopover, { orderItems: orderItems, currentOrderItem: currentOrderItem, anchorEl: anchorEl, onClose: handlePopoverClose, onOrderChange: onItemClick })] }));
};
